import { render, staticRenderFns } from "./guzhang.vue?vue&type=template&id=1f9cd14e&scoped=true"
import script from "./guzhang.vue?vue&type=script&lang=js"
export * from "./guzhang.vue?vue&type=script&lang=js"
import style0 from "./guzhang.vue?vue&type=style&index=0&id=1f9cd14e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9cd14e",
  null
  
)

export default component.exports